import { plecoDefaultToneColorsLight } from "@-/com.npmjs.pleco-default-tone-colors";

const uppercaseHex = (hex: string) => hex.toUpperCase();

/** Pleco-standard tone palette: 1st=red, 2nd=green, 3rd=blue, 4th=purple, neutral(0)=grey. */
export const PLECO_TONE_COLORS = {
  tone0Color: uppercaseHex(plecoDefaultToneColorsLight.tone0),
  tone1Color: uppercaseHex(plecoDefaultToneColorsLight.tone1),
  tone2Color: uppercaseHex(plecoDefaultToneColorsLight.tone2),
  tone3Color: uppercaseHex(plecoDefaultToneColorsLight.tone3),
  tone4Color: uppercaseHex(plecoDefaultToneColorsLight.tone4),
} as const;
